Unsplash = require('unsplash-js/dist/unsplash')
parseURL = require 'url-parse'
_ = require 'underscore'
$ = require 'jquery'
log = require 'app/scripts/debug/log'

APP_ID = "7066"
BASE_URL = 'https://views.unsplash.com/v?app_id=' + APP_ID
MAX_URL_LENGTH = 2083

# photo is of form http://amazon/more/more/photo-xxxxxxx if it's an unsplash photo
# extract the `/photo-xxxxxx` portion
idFromUrl = (url) -> /(\/photo-)[^\&\.\?\n\#]*/.exec(url)?[0]

# See Unsplash: Tracking and Attribution
# https://hello.atlassian.net/wiki/spaces/TRELLO/pages/563910515/Unsplash+Tracking+and+Attribution

class UnsplashClient
  constructor: ->
    @appId = "454087647775b190c574339cb2994716b17ef2f83ad11838d0ef0dac2d102e66"
    @unsplashApi = new Unsplash.default
      applicationId: @appId

    @constants =
      DEFAULT_COLLECTION_ID: 317099
      PAGE_SIZE: 18
      RAW_PARAMS:
        w: 2560,
        h: 2048,
        q: 90
      ATTRIBUTION_LINK_TRACKING:
        utm_source: 'trello'
        utm_medium: 'referral'
        utm_campaign: 'api-credit'

    @_trackByUrlQueue = []
    @_trackingExpires = new Map()

  toJson: Unsplash.toJson

  parseUserLink: (link) =>
    url = parseURL(link, true)
    url.set('protocol', 'https:')
    _.extend(url.query, @constants.ATTRIBUTION_LINK_TRACKING)

    url.toString()

  getTrackingUrl = (params) ->
    url = BASE_URL
    url += "&#{key}=#{value}" for key, value of params
    url

  trackUnsplashViewsById: (id) =>
      photoIds = (if _.isArray(id) then id else [id]).map((eachId) => encodeURIComponent(eachId))
      trackingUrls = @getChunkedTrackingUrls(photoIds, 'photo_id')

      trackingUrls.forEach (url) ->
        $.get(url).error (e) ->
          if e.status != 200
            log('Unsplash', 'tracking error', url)

  trackUnsplashViews: (photos) =>
    photoIds = []
    photos.forEach((photo) =>
      if photo.isPhoto && photo.metadata.hasOwnProperty('id')
        photoIds.push photo.metadata.id
    )
    @trackUnsplashViewsById photoIds

  trackUnsplashViewBySavedUrl: (urls) =>
    photoPathArray = []
    if _.isArray(urls)
      photoPathArray = urls
    else
      photoPathArray.push(urls)

    allPhotos = []
    photoPathArray.forEach (photo) ->
      photoId = idFromUrl(photo)
      if photoId
        allPhotos.push(encodeURIComponent(photoId))

    if allPhotos.length
      trackingUrls = @getChunkedTrackingUrls(_.clone(allPhotos), 'filepath')

      trackingUrls.forEach (url) ->
        $.get(url).error (e) ->
          if e.status != 200
            log('Unsplash', 'tracking error', url)

  chunk: (arr, segments) ->
    newArr = arr.slice 0
    parts = []
    chunkSize = Math.floor(newArr.length / segments)
    while newArr.length
      parts.push(newArr.splice(0, chunkSize))

    return parts

  getChunkedTrackingUrls: (arr, urlKey, maxLength = MAX_URL_LENGTH) ->
    # NOTE: maxLength is an argument to facilitate unit testing
    if !arr.length || BASE_URL.length > maxLength
      log('Unsplash', 'tracking error', 'wrong input data')
      # return passed in arr, note this will fail the AJAX call but we're logging it
      return arr

    segments = 1
    result = []
    while !result.length || result.some((eachUrl) => eachUrl.length > maxLength)
      allPhotosChunked = @chunk(arr, segments)
      result[index] = getTrackingUrl {
        "#{urlKey}": allPhotosChunked[index].join(',')
      } for index in [0...allPhotosChunked.length]
      segments++

    return result

module.exports = new UnsplashClient()
